export default __webpack_public_path__ + "static/media/cours-anglais-affaires-learn-english.a252ce5f.webp";